import React from 'react'
import { Box, Button, Flex, HStack, Text } from '@chakra-ui/react'

interface IncidentCategoryCardProps {
  title: string
  descriptor: string
  reported: boolean | null
  onReportedChange: (value: boolean | null) => void
  colorScheme?: string
  children?: React.ReactNode
}

const IncidentCategoryCard: React.FC<IncidentCategoryCardProps> = ({
  title,
  descriptor,
  reported,
  onReportedChange,
  colorScheme = 'purple',
  children,
}) => {
  const handleYes = () => {
    onReportedChange(reported === true ? null : true)
  }

  const handleNo = () => {
    onReportedChange(reported === false ? null : false)
  }

  return (
    <Box borderWidth='1px' borderRadius='md' overflow='hidden'>
      <Flex
        align='center'
        justify='space-between'
        p={3}
        bg={`${colorScheme}.50`}
      >
        <Box>
          <Text fontWeight='medium' fontSize='sm'>
            {title}
          </Text>
          <Text fontSize='xs' color='gray.500'>
            {descriptor}
          </Text>
        </Box>
        <HStack spacing={2}>
          <Button
            size='xs'
            variant={reported === true ? 'solid' : 'outline'}
            colorScheme={colorScheme}
            onClick={handleYes}
            data-active={reported === true ? 'true' : undefined}
          >
            Yes
          </Button>
          <Button
            size='xs'
            variant={reported === false ? 'solid' : 'outline'}
            colorScheme='green'
            onClick={handleNo}
            data-active={reported === false ? 'true' : undefined}
          >
            No
          </Button>
        </HStack>
      </Flex>
      {reported === true && children && (
        <Box p={3} borderTopWidth='1px'>
          {children}
        </Box>
      )}
    </Box>
  )
}

export default IncidentCategoryCard
